import { render } from "./PackageExcelImportHistory.vue?vue&type=template&id=47dca226"
import script from "./PackageExcelImportHistory.vue?vue&type=script&lang=js"
export * from "./PackageExcelImportHistory.vue?vue&type=script&lang=js"

import "./PackageExcelImportHistory.vue?vue&type=style&index=0&id=47dca226&lang=scss"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__